import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

export interface FieldsetAttrs {
    label: string
    className?: string
}

export class Fieldset extends MithrilComponent<FieldsetAttrs> {
    view(vnode: m.Vnode<FieldsetAttrs>): m.Children {
        return (
            <div className={`c-fieldset ${vnode.attrs.className || ''}`}>
                <label>{vnode.attrs.label}</label>
                {vnode.children}
            </div>
        )
    }
}
